export default "__VITE_ASSET__JQkaxABa__"